module.exports = __webpack_public_path__ + "img/card3.4a076635.png";